// Module
var code = `{{#rows}}
<div class="{{attrRowClass}}">
  <div class="flex items-center">
    <img
      src="{{attrImageSrc}}"
      alt="{{attrImageAlt}}"
      class="mr-4 rounded-full"
      width="32"
      height="32"
    />
    <div class="min-w-0">
      <p class="truncate text-sm font-semibold md:text-base">{{name}}</p>
      <p class="hidden text-sm text-gray-500 sm:block">{{email}}</p>
    </div>
  </div>
  <p class="font-lusitana truncate text-sm font-medium md:text-base">
    {{amount}}
  </p>
</div>
{{/rows}}
`;
// Exports
module.exports = code;